module.exports = __webpack_public_path__ + "static/img/icon-20.f6a9826.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-20.png
// module id = YL8T
// module chunks = 1